import Game from "./components/Game/Game";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import TopBar from "./components/TopBar/TopBar";

import "./App.css";
import Home from "./components/Home/Home";
import Results from "./components/Results/Results";
import Debrief from "./components/Debrief/Debrief";
import { useGame } from "./contexts/GameProvider";

function App() {
    const { gameState } = useGame();

    return (
        <div className="App">
            <Router>
                <TopBar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route
                        path="/play"
                        element={
                            gameState.name ? <Game /> : <Navigate to="/" />
                        }
                    />
                    <Route
                        path="/complete"
                        element={
                            gameState.subtitles &&
                            gameState.subtitles.filter((el) => el.flagged)
                                .length ? (
                                <Debrief />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    />
                    <Route path="/results/:id" element={<Results />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;
